/**
 * lg-reviews-footer-trigger.js
 * Shows the .lg-reviews-fab button only when the page footer
 * is visible (or approaching) in the viewport.
 */
(function () {
  function init() {
    var fab = document.querySelector('.lg-reviews-fab');
    if (!fab) return;

    fab.style.opacity = '0';
    fab.style.transform = 'translateY(20px)';
    fab.style.pointerEvents = 'none';
    fab.style.transition = 'opacity 0.35s ease, transform 0.35s ease, box-shadow 0.2s ease';

    function show() {
      fab.style.opacity = '1';
      fab.style.transform = 'translateY(0)';
      fab.style.pointerEvents = 'auto';
    }

    function hide() {
      fab.style.opacity = '0';
      fab.style.transform = 'translateY(20px)';
      fab.style.pointerEvents = 'none';
    }

    var footer =
      document.querySelector('footer') ||
      document.querySelector('[id*="footer"]') ||
      document.querySelector('.shopify-section--footer');

    if (!footer) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            show();
          } else {
            hide();
          }
        });
      },
      {
        rootMargin: '200px 0px 0px 0px',
        threshold: 0
      }
    );

    observer.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();